import { FC } from 'react';
import Button from 'v3/common/components/Button';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import UserInput from 'v3/common/components/UserInput';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

const SkyBroking: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { updatePartialConfigs, reDirectPage, isMobile } = brokerSpecificHandles;
  const { clientId, token, selectedBrokerConfig, isLoading } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        reDirectPage({ token }, false);
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-id`}
        value={clientId}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />
      <UserInput
        labelValue="Token"
        id={`${broker}-token`}
        value={token}
        onHandleChange={(value) => updatePartialConfigs({ token: value })}
      />
      <div className="my-2 alert alert-warning py-1 px-2">
        Please follow the instructions below to obtain a token.
        <br />
        <ul>
          <li>
            Login{' '}
            <a href="https://skypro.skybroking.com/" target="_blank" rel="noreferrer">
              skypro
            </a>
          </li>
          <li>Go to profile section</li>
          <li>Click API key</li>
          <li>Choose QUANTMAN in vendor</li>
          <li>Generate API token and paste in appropriate field</li>
        </ul>
      </div>

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          Login
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default SkyBroking;
